import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=5313a2b7&"
import script from "./Posts.vue?vue&type=script&lang=js&"
export * from "./Posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5313a2b7')) {
      api.createRecord('5313a2b7', component.options)
    } else {
      api.reload('5313a2b7', component.options)
    }
    module.hot.accept("./Posts.vue?vue&type=template&id=5313a2b7&", function () {
      api.rerender('5313a2b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Posts.vue"
export default component.exports